var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddCloud = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "30px",
    viewBox: "0 0 32 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 1070") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Installer-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(-639.000000, -472.000000)",
    fill: "#7A7A7A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(268.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(222.000000, 79.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 75.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-1070",
    transform: "translate(148.999454, 78.681818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3436369,5.22545455 C22.6527278,2.03727273 19.299546,0 15.6818187,0 C10.7481823,0 6.61636414,3.67227273 5.96863687,8.49136364 C2.74363687,8.24590909 -0.00136312852,10.8422727 5.078436e-07,14.0495455 C5.078436e-07,18.2086364 3.34363687,19.5586364 5.45454596,19.7468182 L5.45454596,13.6363636 C5.45454596,12.5086364 6.37227324,11.5909091 7.50000051,11.5909091 L22.5000005,11.5909091 C23.6277278,11.5909091 24.5454551,12.5086364 24.5454551,13.6363636 L24.5454551,19.7727273 C26.0727278,19.7727273 31.3636369,18.0177273 31.3636369,12.4186364 C31.3636369,8.50909091 28.2300005,5.31681818 24.3436369,5.22545455",
    id: "Fill-2603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8187278,27.9545455 L8.18236414,27.9545455 L8.18236414,25.6977273 L10.3996369,21.1759091 C10.6314551,20.7068182 11.2737278,20.67 11.5669096,21.0818182 L13.8632732,24.3027273 L17.9978187,17.0481818 C18.2978187,16.5272727 19.0478187,16.6227273 19.2360005,17.1627273 L21.8187278,24.5959091 L21.8187278,27.9545455 Z M12.2732732,15.6818182 C13.0260005,15.6818182 13.6369096,16.2940909 13.6369096,17.0454545 C13.6369096,17.7968182 13.0260005,18.4090909 12.2732732,18.4090909 C11.520546,18.4090909 10.9096369,17.7968182 10.9096369,17.0454545 C10.9096369,16.2940909 11.520546,15.6818182 12.2732732,15.6818182 L12.2732732,15.6818182 Z M22.500546,12.9545455 L7.50054596,12.9545455 C7.12418233,12.9545455 6.81872778,13.26 6.81872778,13.6363636 L6.81872778,28.6363636 C6.81872778,29.0127273 7.12418233,29.3181818 7.50054596,29.3181818 L22.500546,29.3181818 C22.8769096,29.3181818 23.1823641,29.0127273 23.1823641,28.6363636 L23.1823641,13.6363636 C23.1823641,13.26 22.8769096,12.9545455 22.500546,12.9545455 L22.500546,12.9545455 Z",
    id: "Fill-2604"
  })))))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddCloud);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add_cloud.5f92e6f9df97c4ddca1a458ef089dd88.svg";